import './styles.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Video from 'Components/layout/Video';

export default class VideoCaseStudySolutionV2 extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired
    };

    render() {
        const { data } = this.props;

        return (
            <div className="component-video-case-study-solution-v2">
                <div className="v3-container">
                    <div className="section-block">
                        <h3 className="block-title">{data.title}</h3>
                        <p className="block-text" dangerouslySetInnerHTML={{ __html: data.subtitle }} />
                    </div>
                </div>
                {data.sideBg && <img className="background-side" src={data.sideBg} />}
                {data.photo0 && <img className="photo-side photo-side-0" src={data.photo0} />}
                {data.photo1 && <img className="photo-side photo-side-1" src={data.photo1} />}
                {data.photo2 && <img className="photo-side photo-side-2" src={data.photo2} />}
                {data.photo3 && <img className="photo-side photo-side-3" src={data.photo3} />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/videoCaseStudy/SolutionV2/index.js